import React, { FunctionComponent, useContext } from 'react';
import { useSearchParams } from 'react-router-dom';

// Custom components
import AppPage from '@/ui/AppPage/AppPage';
import Permissions from '@/lib/permissions';
import DataCentricPage from '@/ui/DataCentric/DataCentricPage';
import UserContext from '@/context/UserContext/UserContext';
import PPZahtjeviDialog from './PPZahtjeviDialog';

// Models
import modelPPZahtjev from '@/models/pp_zahtjev';
import modelPPZahtjevKC from '@/models/pp_zahtjev_kc';

const PPZahtjeviPage: FunctionComponent = () => {
  const userContext = useContext(UserContext);

  const canEdit = userContext?.hasAnyPermission([Permissions.PPZahtjeviManage]);

  const [searchParams] = useSearchParams();

  const idParam = searchParams.get('id');
  const initialOpenId = idParam ? parseInt(idParam, 10) : undefined;

  return (
    <AppPage titlett="pp:page.zahtjevi" needPermission={[Permissions.PPZahtjeviView]}>
      <DataCentricPage
        primaryModel={modelPPZahtjev}
        primaryTitleToken="pp:titles.pp_zahtjevi"
        primaryView="default"
        primaryAllowView
        primaryAllowEdit={canEdit}
        primaryAllowDocumentButton
        primaryInitialSelectedId={initialOpenId}
        secondaryModel={modelPPZahtjevKC}
        secondaryTitleToken="pp:titles.pp_zahtjev_kc"
        secondaryView="default"
        secondaryAllowEdit={canEdit}
        secondaryAllowColumnPicker
        secondaryAllowExport
        allowShowSecondaryOnMap
        replacePrimaryIdInSecondaryPath
        baseRecordPath={modelPPZahtjev.apiPath}
        childRecordRelativePath="cestice"
        secondaryDialogComponent={PPZahtjeviDialog}
        geomRelativePath=""
        mapId={71}
        mapModel={modelPPZahtjev}
        refreshPriamryOnSecondaryRefresh
      />
    </AppPage>
  );
};

export default PPZahtjeviPage;
